import { render, staticRenderFns } from "./DynamicImage.vue?vue&type=template&id=677a5d80&scoped=true"
import script from "./DynamicImage.vue?vue&type=script&lang=ts"
export * from "./DynamicImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a5d80",
  null
  
)

export default component.exports